<template>
  <div class="container-root">
    <div class="header-text">{{ getWelcomeText() }}</div>
    <!-- <div class="attendance-box" v-if="clockInStuff.loading">
      <div class="loader"></div>
    </div>
    <div v-else-if="isWeekendOrPublicHolidays()">You don't need to clock in today.</div>
    <div v-else-if="profile.ignore_attendance">Clock in is ignored for you</div>
    <div class="attendance-box" v-else>
      <div class="attendance-log">
        <div>
          <b>Attendance Log -</b>
          {{ getAttendanceLog }}
        </div>
        <div style="color:#7f8c8d">{{getCurrentTime}}</div>
      </div>
      <div class="loader" v-if="clockInStuff.isClocking"></div>
      <button
        v-else-if="!hasClockedIn"
        class="button dark-blue"
        style="display:flex;justify-content:center;"
        @click="clockIn"
      >
        <i style="margin-right:5px;margin-top:1px;" class="far fa-clock"></i>
        <div>CLOCK IN</div>
      </button>
      <button
        v-else-if="shouldShowClockOut"
        class="button dark-blue"
        style="display:flex;justify-content:center;"
        @click="clockOut"
      >
        <i style="margin-right:5px;margin-top:1px;" class="far fa-clock"></i>
        <div>CLOCK OUT</div>
      </button>
    </div>-->
    <div class="grid">
      <div class="container grid-col">
        <div class="activities">
          <div class="box-header">My Activities</div>
          <div class="box">
            <div
              class="box-elem"
              v-for="(item, index) in myActivities"
              :key="index"
              @click="$emit('update:selectedNav', item.nav)"
            >
              <i :class="item.icon"></i>
              <div>{{ item.text }}</div>
            </div>
          </div>
        </div>
        <div class="activities" v-if="profile.role === 'admin'">
          <div class="box-header">Staff Activities</div>
          <div class="box">
            <div
              class="box-elem"
              v-for="(item, index) in staffActivities"
              :key="index"
              @click="onClickStaff(item)"
            >
              <i :class="item.icon"></i>
              <div>{{ item.text }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid-col">
        <div class="container notif">
          <div class="box-header">Notification Centre</div>
          <div class="box notif">
            <div class="notif-group" v-if="notifications.loading">
              <div class="loader"></div>
            </div>
            <div
              class="notif-group"
              v-for="(item, index) in notifications.data"
              :key="index"
              v-else
            >
              <div class="notif-header">
                <div class="notif-title">{{ item.title }}</div>
                <div class="notif-date">{{ item.date }}</div>
              </div>
              <hr class="notif-separator" />
              <div class="notif-body">{{ item.desc }}</div>
            </div>
          </div>
        </div>
        <div class="container calendar">
          <Calendar
            ref="cal"
            :profile="profile"
            @onClickEvent="onClickEvent"
          ></Calendar>
        </div>
      </div>
    </div>
    <Modal
      v-if="calendarEventStuff.showing"
      :isShowing.sync="calendarEventStuff.showing"
      :title="
        `${calendarEventStuff.id ? 'Update' : 'Add a New'} Calendar Event`
      "
    >
      <CalendarEvent
        :id="calendarEventStuff.id"
        @onEventAction="onEventAction"
      />
    </Modal>
    <Notif v-if="notif" :data.sync="notif" />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import Fingerprint from 'fingerprintjs';
import { http, utils } from '../digilib_web/core/digitify';
// import { regentsUtils } from '../js/regents'
import Calendar from '../components/common/calendar';
import Notif from '../digilib_web/vue/notif';
import Modal from '../digilib_web/vue/modal';
import CalendarEvent from './calendar_event';

export default {
  props: {
    profile: Object,
    selectedNav: String
  },
  mounted() {
    this.reloadAttendance();
    // load notifs
    let profile = this.profile;
    let d = dayjs();
    let curMonth = d.format('M');
    console.log(curMonth);
    let startOfMonth = d.startOf('month').format('YYYY-MM-DD');
    // get payslips availability for this month
    let endpoint = `employees/payslips?where=id_employee,=,${
      profile.id
    }|payment_date,>,${startOfMonth}|is_published,=,true`;
    http.get(endpoint).then(json => {
      if (json.data.length > 0) {
        this.notifications.data.push({
          title: 'Payslip',
          desc: `${d.format('MMMM')} Payslip now available to download`
        });
      }
      let isPrincipal = profile.job_category === 'Principal';
      let isAdminOrPrincipal = profile.role === 'Admin' || isPrincipal;
      if (isAdminOrPrincipal) {
        // if admin, check monthly timeoffs that have not been approved with the same department as the logged in
        let endpoint = `employees/timeoffs/monthly/${curMonth}?where=is_approved,is,null`;
        if (isPrincipal) {
          endpoint = `${endpoint}|department,=,${profile.department}`;
        }
        http.get(endpoint).then(json => {
          for (let i = 0; i < json.data.length; ++i) {
            let timeOff = json.data[i];
            let timeOffType = timeOff.type;
            this.notifications.data.push({
              title: `Pending Request`,
              desc: `${timeOff.employee_name} requested for ${timeOffType}`
            });
          }
          this.notifications.loading = false;
        });
      } else {
        // if user, show monthly timeoffs that have been approved for the particular user
        let endpoint = `employees/timeoffs/monthly/${curMonth}?where=id_employee,=,${
          profile.id
        }|is_approved,isnot,null`;
        http.get(endpoint).then(json => {
          for (let i = 0; i < json.data.length; ++i) {
            let timeOff = json.data[i];
            let timeOffType = timeOff.type;
            let status = timeOff.is_approved ? 'approved' : 'rejected';
            let desc = `${timeOffType} request for ${this.convertDatesInfo(
              timeOff.dates
            )} was ${status} by ${timeOff.approved_by}`;
            this.notifications.data.push({
              title: `${timeOffType} Request ${status}`,
              desc: desc
            });
          }
          this.notifications.loading = false;
        });
      }
    });
  },
  methods: {
    getWelcomeText() {
      let profile = this.profile;
      let empNo = profile.employee_no ? `(${profile.employee_no})` : '';
      return `Welcome Back, ${profile.name} ${empNo}`;
    },
    validateClocking() {
      // if (!this.isClockingAllowed) {
      //   alert(`You can't clock in / out using a different mobile device`)
      //   return false
      // }
      if (!navigator.geolocation) {
        alert('Your browser does not support geolocation');
        return false;
      }
      if (!this.isMobile()) {
        alert('You need to use a mobile device to clock in');
        return false;
      }
      return true;
    },
    onClickEvent(ev) {
      this.calendarEventStuff.showing = true;
      this.calendarEventStuff.id = ev.id;
    },
    onClickStaff(item) {
      if (item.nav) {
        this.$emit('update:selectedNav', item.nav);
      } else {
        this.calendarEventStuff.showing = true;
        this.calendarEventStuff.id = null;
      }
    },
    onEventAction(txt) {
      this.notif = { text: txt, color: 'green' };
      this.calendarEventStuff.showing = false;
      this.$refs.cal.reloadEvents();
    },
    isWeekendOrPublicHolidays() {
      let d = dayjs();
      let theDay = d.day();
      if (theDay === 0 || theDay === 6) {
        return true;
      }
      return this.isPublicHoliday;
    },
    isMobile() {
      return (
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)
      );
    },
    convertDatesInfo(dates) {
      let convertedDates = '';
      let len = dates.length;
      for (let i = 0; i < len; ++i) {
        convertedDates += dayjs(dates[i]).format('D-M-YYYY');
        convertedDates += ', ';
      }
      return convertedDates;
    },
    getLongLatCenterPoint() {
      switch (this.profile.department) {
        case 'Primary':
          return {
            latitude: -8.663643707664521,
            longitude: 115.22982292589172,
            radius: 0.008
          };
        case 'Preschool':
          return {
            latitude: -8.66499441637314,
            longitude: 115.23614779137475,
            radius: 0.01
          };
        case 'Secondary':
          return { latitude: -8.6506042, longitude: 115.2489652, radius: 0.2 };
      }
    },
    isWithinRadius(fn) {
      this.clockInStuff.isClocking = true;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(pos => {
          let centerPoint = this.getLongLatCenterPoint();
          // check if within radius
          let withinRadius = utils.arePointsNear(
            pos.coords,
            centerPoint,
            centerPoint.radius
          );
          if (!withinRadius) {
            alert('You are not within radius from the school');
          }
          this.clockInStuff.isClocking = false;
          return fn(withinRadius);
        });
      }
    },
    reloadAttendance() {
      let profile = this.profile;
      let today = dayjs().format('YYYY-MM-DD');
      let endpoint = `employees/attendance?where=id_employee,=,${
        profile.id
      }|date,=,${today}`;
      this.clockInStuff.loading = true;
      http.get(endpoint).then(json => {
        let fingerprint = new Fingerprint().get().toString();
        this.clockInStuff.curBrowserFP = fingerprint;
        if (json.success && json.data.length > 0) {
          this.clockInStuff.data = json.data[0];
        }
        // check whether today is public holiday
        let curYear = dayjs().year();
        http
          .get(`calendars/${curYear}?where=date,=,${today}&select=type`)
          .then(json => {
            let data = json.data;
            if (data.length > 0) {
              let type = data[0].type;
              this.isPublicHoliday =
                type === 'School Holiday' || type === 'Public Holiday';
            }
            // get attendance annually if not ignoring attendance
            if (!profile.ignore_attendance) {
              let d = dayjs();
              let curYear = d.year();
              // let endpoint = `employees/attendance?select=clock_in,clock_out&where=id_employee,=,${profile.id}|date,>=,${curYear}-01-01|date,<=,${curYear}-12-31`
              let endpoint = `employees/attendance/deductions?where=id_employee,=,${
                profile.id
              }|date,>=,${curYear}-01-01|date,<=,${curYear}-12-31`;
              http.get(endpoint).then(json => {
                // let countLate = regentsUtils.countAnnualLateness(json.data, profile.department)
                let countLate = 0;
                json.data.forEach(i => {
                  if (i.type === 'Late') {
                    countLate++;
                  }
                });
                this.notifications.data.push({
                  title: `Lateness count`,
                  desc: `You're late ${countLate} time(s) this year`
                });
                // check if today i am late ?
                // if (this.clockInStuff.data) {
                //   let clockInTime = this.clockInStuff.data.clock_in
                //   if (!regentsUtils.isOnTime(profile, clockInTime)) {
                //     let fmt = dayjs(clockInTime).format('hh:mm')
                //     this.notifications.data.push({ title: `Late today`, desc: `You're late today, clocked in at ${fmt}` })
                //   }
                // }
                // set not loading
                this.clockInStuff.loading = false;
              });
            }
          });
      });
    },
    clockIn() {
      if (!this.validateClocking()) {
        return;
      }
      if (this.hasClockedIn) {
        this.notif = {
          text: 'You have already clocked in today',
          color: 'red'
        };
        return;
      }
      this.isWithinRadius(flag => {
        if (flag) {
          this.clockInStuff.loading = true;
          let fp = this.clockInStuff.curBrowserFP;
          let endpoint = `employees/clockin/${this.profile.id}/${fp}`;
          http.get(endpoint).then(json => {
            let success = json.success;
            if (success) {
              this.notif = {
                text: json.data
                  ? 'Successfully clocked in'
                  : 'Unable to clock in',
                color: json.data ? 'green' : 'red'
              };
              this.reloadAttendance();
            } else {
              this.notif = { text: 'Unable to clock in', color: 'red' };
            }
          });
        }
      });
    },
    clockOut() {
      if (confirm('Are you sure to clock out?')) {
        if (!this.validateClocking()) {
          return;
        }
        if (this.hasClockedOut) {
          this.notif = {
            text: 'You have already clocked out today',
            color: 'red'
          };
          return;
        }
        this.isWithinRadius(flag => {
          if (flag) {
            this.clockInStuff.loading = true;
            let fp = this.clockInStuff.curBrowserFP;
            let endpoint = `employees/clockout/${this.clockInStuff.data.id}/${
              this.profile.id
            }/${fp}`;
            http.get(endpoint).then(json => {
              let success = json.success;
              if (success) {
                this.notif = {
                  text: json.data
                    ? 'Successfully clocked out'
                    : 'Unable to clock out',
                  color: json.data ? 'green' : 'red'
                };
                this.reloadAttendance();
              } else {
                this.notif = { text: 'Unable to clock in', color: 'red' };
              }
            });
          }
        });
      }
    }
  },
  computed: {
    isClockingAllowed() {
      // only allow clocking when fingerprint is null
      // when it's not, check against the cur browser FP
      return (
        this.profile.fingerprint === null ||
        this.clockInStuff.curBrowserFP === this.profile.fingerprint
      );
    },
    shouldShowClockOut() {
      return this.hasClockedIn && !this.hasClockedOut;
    },
    hasClockedOut() {
      return this.clockInStuff.data.clock_out !== null;
    },
    hasClockedIn() {
      return this.clockInStuff.data && this.clockInStuff.data.clock_in !== null;
    },
    getCurrentTime() {
      return this.hasClockedIn
        ? ''
        : dayjs().format('ddd, DD MMM YYYY | hh:mm');
    },
    getAttendanceLog() {
      if (this.hasClockedIn) {
        let c = this.clockInStuff.data;
        let clockInTime = dayjs(c.clock_in).format('hh:mm');
        let clockOutTime = c.clock_out
          ? ` and clocked out at ${dayjs(c.clock_out).format('hh:mm')}`
          : '';
        return `You clocked in at ${clockInTime} ${clockOutTime}`;
      }
      return `Please Remember to clock in as soon as you're arrived at the school.`;
    }
  },
  data() {
    return {
      notif: null,
      isPublicHoliday: false,
      clockInStuff: {
        loading: true,
        data: null,
        isClocking: false,
        curBrowserFP: ''
      },
      calendarData: { currentYear: null, isLoadingEvent: false, events: [] },
      calendarEventStuff: { showing: false, id: null },
      myActivities: [
        { icon: 'far fa-user', text: 'My Details', nav: 'MyDetails' },
        { icon: 'far fa-file-alt', text: 'My Payslips', nav: 'MyPayslips' },
        { icon: 'far fa-clock', text: 'My Attendance', nav: 'MyAttendance' },
        { icon: 'far fa-calendar-check', text: 'My Time Off', nav: 'MyTimeoff' }
      ],
      staffActivities: [
        { icon: 'fas fa-users', text: 'Staff Details', nav: 'StaffDetails' },
        {
          icon: 'far fa-file-alt',
          text: 'Staff Payslips',
          nav: 'StaffPayslips'
        },
        { icon: 'far fa-calendar-check', text: 'Add Calendar Event' }
      ],
      notifications: { data: [], loading: true }
    };
  },
  components: {
    Calendar,
    CalendarEvent,
    Notif,
    Modal
  }
};
</script>

<style scoped>
.header-text {
  text-transform: uppercase;
  font-size: 1.3em;
  font-weight: bold;
  padding: 10px 0 10px 0;
}
.attendance-box {
  box-shadow: 0 0 1px 1px rgba(222, 226, 222, 0.5);
  margin-bottom: 10px;
  padding: 10px;
  display: flex;
  flex-flow: row;
  justify-content: space-between;
}
.attendance-log {
  display: flex;
  flex-flow: column;
}
.attendance-btn-group {
  display: flex;
}
.attendance-btn-group > button {
  margin-left: 10px;
}
.grid {
  display: flex;
  min-height: 600px;
}
.grid-row {
  display: flex;
  flex-flow: column;
  justify-content: space-between;
}
.grid-col {
  flex: 1 50%;
  display: flex;
  flex-flow: column;
}
.grid-col:nth-child(even) {
  margin-left: 20px;
}
.activities {
  flex: 1;
  display: flex;
  flex-flow: column;
}
.container {
  box-shadow: 0 0 1px 1px rgba(222, 226, 222, 0.5);
}
.container.calendar {
  padding: 10px;
  height: 380px;
}
.container.notif {
  margin-bottom: 20px;
  flex: 1;
}
.box {
  display: flex;
  flex-wrap: wrap;
  flex: 1 100%;
}
.box-elem {
  flex: 1 0 50%;
  text-align: center;
  color: #5fb6a5;
  border: 1px solid rgba(222, 226, 222, 0.3);
  cursor: pointer;
  display: flex;
  flex-flow: column;
  justify-content: center;
  padding-top: 10px;
}
.box-elem > i {
  padding-top: 10px;
  font-size: 60px;
}
.box-elem > div {
  font-size: 1em;
  text-transform: uppercase;
  margin: 10px 0 40px;
}
.box-header {
  background-color: #f7f8f7;
  padding: 10px;
  font-size: 1rem;
  font-weight: bold;
  line-height: 1.1;
  text-transform: uppercase;
}
.box.notif {
  flex-flow: column;
  max-height: 240px;
  overflow-y: auto;
}
.notif-group {
  display: flex;
  flex-flow: column;
  padding: 10px;
  flex: 1;
}
.notif-title {
  color: rgba(86, 145, 176, 1);
  font-size: 0.9em;
}
.notif-date {
  color: rgb(194, 197, 194);
}
.notif-header {
  display: flex;
  justify-content: space-between;
}
.notif-separator {
  width: 100%;
  border: 1px solid rgba(222, 226, 222, 0.3);
}
@media screen and (max-width: 960px) {
  .attendance-box {
    flex-flow: column;
  }
  .attendance-box > div {
    margin-bottom: 10px;
  }
  .attendance-btn-group {
    flex-flow: column;
  }
  .attendance-btn-group > button {
    margin-top: 10px;
  }
  .grid {
    display: block;
    margin-bottom: 5px;
  }
  .grid-col:nth-child(even) {
    margin-left: 0px;
  }
  .grid-col {
    margin-bottom: 10px;
  }
  .container.notif {
    margin-bottom: 10px;
  }
  .container.calendar {
    height: 500px;
  }
}
</style>
